import { render, staticRenderFns } from "./AppContent.vue?vue&type=template&id=59795c6f&scoped=true&"
import script from "./AppContent.vue?vue&type=script&lang=js&"
export * from "./AppContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59795c6f",
  null
  
)

export default component.exports